import { TranslationObject } from '../i18n/translation';

const namespace = 'myinstitution.uha';
const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Min institusjon',
    en: 'My institution',
  },
  colleagesTab: {
    id: `${namespace}.colleagesTab`,
    nb: 'Kolleger',
    en: 'Colleagues',
  },
  practicetypesWithReqsTab: {
    id: `${namespace}.practicetypesWithReqsTab`,
    nb: 'Praksistyper med aktivitetskrav',
    en: 'Practice types with requirements',
  },
  practicetypesWithoutReqsTab: {
    id: `${namespace}.practicetypesWithoutReqsTab`,
    nb: 'Praksistyper uten aktivitetskrav',
    en: 'Practice types without requirements',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Her kan du finne en liste over alle kolleger som har en brukerrolle i Arbeidslivsportalen og informasjon om praksistyper.',
    en: 'All your colleagues with access to Arbeidslivsportalen and information regarding practice types.',
  },
  newuser: {
    id: `${namespace}.newuser`,
    nb: 'Inviter ny bruker',
    en: 'Invite new user',
  },
  name: {
    id: `${namespace}.name`,
    nb: 'Medarbeiders navn',
    en: 'Name',
  },
  status: {
    id: `${namespace}.status`,
    nb: 'Status',
    en: 'Status',
  },
  role: {
    id: `${namespace}.role`,
    nb: 'Rolle',
    en: 'Role',
  },
  email: {
    id: `${namespace}.email`,
    nb: 'Epost',
    en: 'Email',
  },
  affiliation: {
    id: `${namespace}.affiliation`,
    nb: 'Tilhørighet',
    en: 'Affiliation',
  },
  action: {
    id: `${namespace}.action`,
    nb: 'Handling',
    en: 'Action',
  },
  deleteUser: {
    id: `${namespace}.deleteUser`,
    nb: 'Slett bruker',
    en: 'Delete user',
  },
  confirmDeleteTitle: {
    id: `${namespace}.confirmDeleteTitle`,
    nb: 'Bekreft sletting av bruker',
    en: 'Confirm user deletion',
  },
  confirmDeleteUser: {
    id: `${namespace}.confirmDeleteUser`,
    nb: 'Er du sikker på at du vil slette {name} som bruker?',
    en: 'Are you sure you want to delete {name} as a user?',
  },
  confirmDeleteUserWithActivities1: {
    id: `${namespace}.confirmDeleteUserWithActivities1`,
    nb: 'Er du sikker på at du vil slette {name} som bruker?',
    en: 'Are you sure you want to delete {name} as a user?',
  },
  confirmDeleteUserWithActivities2: {
    id: `${namespace}.confirmDeleteUserWithActivities2`,
    nb: 'Brukeren er registrert på {numActivities} fremtidige aktiviteter og vil bli fjernet fra disse.',
    en: 'This user is registered on {numActivities} future activities and will be removed from these.',
  },
  deleteSucceeded: {
    id: `${namespace}.deleteSucceeded`,
    nb: 'Bruker slettet',
    en: 'User successfully deleted',
  },
};

export default translations;
